module.exports = __webpack_public_path__ + "img/milestone__1934.64761d9c.jpg";